var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.prefix = require("./prefix");
company.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/company/index.js
// module id = 1121
// module chunks = 0